module.exports =  {

  whatIsMyTokens: {
    title: '什么是“我的代币”?',
    contents: `
      <p>“我的代币”是一个查看、管理您的代币资产的页面。您可以随时在您关注的代币列表上添加或删除代币。对于每一种关注的代币，您可以看到您的代币余额、接收或发送代币、管理代币的交易授权、并可以搜索买入或卖出这种代币的挂单。</p>
    `,
  },

  howToGetStarted: {
    title: '我是新手，如何开始？',
    contents: `
      <p>在开始交易之前，您需要：</p>
      <ul class="mb-2">
        <li><strong>包装ETH</strong>：因为历史原因，以太币(ETH) 本身并不符合ERC20代币的标准，因此不能直接和其它ERC20代币交易。目前的解决办法是把ETH兑换成与之等值的ERC20代币WETH，使用WETH交易。WETH和ETH永远是1:1的兑换率，您可以随时在LedgerDex把ETH兑换成WETH（这一步骤叫做“包装ETH”或“Wrap”）或者把WETH兑换成ETH（这一步骤叫做“卸装WETH”或“Unwrap”)。</li>
        <li><strong>添加代币的交易授权</strong>：为保证智能合约能够完成您的交易，您需要授予智能合约为您的账户进行交易的权力委托。这一过程叫做“交易授权”或“Allowance”。您可以随时添加或取消授权。对于每一种您需要卖出的代币您都需要事先单独添加交易授权。</li>
      </ul>
    `,
  },

  whatAreWETHWrapUnwrap: {
    title: '什么是WETH、包装ETH、卸装WETH？',
    contents: `
      <p>WETH就是“经过包装的以太币ETH”。因为历史原因，以太币(ETH) 本身并不符合ERC20代币的标准，因此不能直接和其它ERC20代币交易。目前的解决办法是把ETH兑换成与之等值的ERC20代币WETH，使用WETH交易。WETH和ETH永远是1:1的兑换率，您可以随时在LedgerDex把ETH兑换成WETH（这一步骤叫做“包装ETH”或“Wrap”）或者把WETH兑换成ETH（这一步骤叫做“卸装WETH”或“Unwrap”)。
      </p>
    `,
  },

  whatIsAllowance: {
    title: '什么是交易授权？',
    contents: `
      <p>为保证智能合约能够完成您的交易，您需要授予智能合约为您的账户进行交易的权力委托。这一过程叫做“交易授权”或“Allowance”。您可以随时添加或取消授权。对于每一种您需要卖出的代币您都需要事先单独添加交易授权。
      </p>
    `,
  },

  howToAddNewToken: {
    title: '如何添加代币？',
    contents: `
      <p>如果需要添加新代币，您可以访问”我的代币“页面，点击页面上绿色的“+”大按钮，然后您会看到一个添加代币的新窗口， 在这里您可以通过两种方式添加代币：1）从经过认证的代币中选择，2）输入代币的合约地址，通过搜索来添加代币。</p>
    `,
  },

  howToRemoveToken: {
    title: '如何移除已关注的代币？',
    contents: `
      <p>如果想从您关注的代币列表中移除代币，请访问该代币的对应页面，点击“取消关注”按钮。移除代币并不会影响您对这一代币的拥有权和余额。如果需要，您可以随时把这种代币添加回来。
       </p>
    `,
  },

  howToFindOrdersForAToken: {
    title: '如何查看代币的交易挂单？',
    contents: `
      <p>对于每一种代币，您可以查看买入或卖出这种代币的挂单簿。若想查看卖出单，可以点击这一代币在列表中对应的“卖出单”按钮，然后在下拉菜单中选择买入代币，点击之后就可看到挂单了。若想查看买入单，点击这一代币在列表中对应的“买入单”按钮，然后在下拉菜单中选择卖出货币，点击之后就可以看到对应的挂单了。
       </p>
    `,
  },

  couldNotFindTokenPair: {
    title: "为什么在“买入单”或“卖出单”的下拉菜单里找不到我要找的代币？",
    contents: `
      <p>“买入单”和“卖出单”的下拉菜单中仅列出您已关注的代币，如果想要在这里看到其它代币，您需要先添加这种代币到“我关注的代币”列表。
       </p>
    `,
  },

}

